<div class="team">
  <!-- The whole header opens and closes the section, like the mockups/pages panels;
       the title is the keyboard-reachable control for it. -->
  <div class="team-head" (click)="toggleExpanded()">
    <button class="team-toggle" type="button" [attr.aria-expanded]="expanded()">
      <svg class="team-chev" [class.open]="expanded()" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <polyline points="9 18 15 12 9 6" />
      </svg>
      <span class="team-label">Project Team</span>
    </button>

    <button
      class="team-add-toggle"
      type="button"
      [disabled]="busy()"
      (click)="toggleAdding($event)"
      [attr.aria-expanded]="adding()"
    >
      <mat-icon>{{ adding() ? 'close' : 'person_add' }}</mat-icon>
      {{ adding() ? 'Cancel' : 'Add' }}
    </button>
  </div>

  @if (!expanded()) {
    <!-- Closed: just who is on the team. -->
    @if (loading()) {
      <div class="team-state">Loading the team…</div>
    } @else if (items().length) {
      <div class="team-chips">
        @for (member of items(); track member.email) {
          <span class="team-chip" [title]="member.email">{{ member.name }}</span>
        }
      </div>
    }
  } @else {
    @if (adding()) {
      <div class="team-add">
        <input
          class="team-field"
          type="email"
          placeholder="Email (required)"
          [value]="draftEmail()"
          [disabled]="busy()"
          (input)="draftEmail.set($any($event.target).value)"
          (keydown.enter)="submit()"
          aria-label="Stakeholder email"
        />
        <input
          class="team-field"
          type="text"
          placeholder="Name"
          [value]="draftName()"
          [disabled]="busy()"
          (input)="draftName.set($any($event.target).value)"
          (keydown.enter)="submit()"
          aria-label="Stakeholder name"
        />
        <select
          class="team-field"
          [value]="draftRole()"
          [disabled]="busy()"
          (change)="onDraftRole($event)"
          aria-label="Stakeholder role"
        >
          @for (option of assignableRoleOptions; track option.value) {
            <option [value]="option.value" [selected]="option.value === draftRole()">
              {{ option.label }}
            </option>
          }
        </select>
        <button class="team-save" type="button" [disabled]="!canAdd()" (click)="submit()">
          {{ busy() ? 'Adding…' : 'Add' }}
        </button>
      </div>
    }

    @if (loading()) {
      <div class="team-state">Loading the team…</div>
    } @else if (!items().length) {
      <div class="team-state">
        Nobody yet — whoever creates the round, leaves feedback, or comments is added here
        automatically.
      </div>
    } @else {
      <div class="team-members">
        @for (member of items(); track member.email) {
          <!-- The whole card opens the member's email preferences; the name is the
               keyboard-reachable control for it. The role dropdown and remove button
               stop their clicks so they never open it. -->
          <div class="team-member" (click)="onSelectMember(member)">
            @if (member.pictureUrl) {
              <img
                class="team-avatar team-avatar-photo"
                [src]="member.pictureUrl"
                alt=""
                referrerpolicy="no-referrer"
                (error)="onPictureError(member.pictureUrl)"
              />
            } @else {
              <span class="team-avatar" [style.background]="member.color">{{ member.initials }}</span>
            }

            <!-- Name, email and role, one per line. -->
            <div class="team-text">
              <div class="team-name">
                <button
                  class="team-name-button"
                  type="button"
                  (click)="$event.stopPropagation(); onSelectMember(member)"
                  [attr.aria-label]="'Email preferences for ' + member.name"
                  title="Email preferences"
                >
                  {{ member.name }}
                </button>
                @if (member.isOwner) {
                  <span class="team-owner" title="Project owner">Owner</span>
                }
              </div>
              @if (member.email) {
                <div class="team-email" [title]="member.email">{{ member.email }}</div>
              }
              <select
                class="team-role"
                [value]="member.role ?? ''"
                [disabled]="busy()"
                (click)="$event.stopPropagation()"
                (change)="onRoleChange(member, $event)"
                [attr.aria-label]="'Role for ' + member.name"
              >
                @for (option of member.roleOptions; track option.value) {
                  <option [value]="option.value" [selected]="option.value === member.role">
                    {{ option.label }}
                  </option>
                }
              </select>
            </div>

            @if (!member.isOwner) {
              <button
                class="team-remove"
                type="button"
                [disabled]="busy()"
                (click)="$event.stopPropagation(); onRemove(member.email)"
                [attr.aria-label]="'Remove ' + member.name + ' from the project team'"
                [title]="'Remove ' + member.name"
              >
                <mat-icon>close</mat-icon>
              </button>
            }
          </div>
        }
      </div>
    }
  }
</div>
